/* sb-gp-behaviours.js: what the GemPages runtime did for the transplanted gp sections (sections/sb-gp-*.liquid,
   generated by kit/convert/gempages/run.mjs), rewritten small and dependency-free:
   carousels (gp-carousel / gp-carousel-v3: slides per view, gap, sneak peek, arrows, dots, swipe, loop, autoplay),
   marquees (gp-marquee), tabs (gp-tab), accordions (gp-accordion), dialogs (gp-dialog + "open-popup" links),
   scroll-to links (gp-button "#id" links, #scroll-to-top), videos (gp-lite-html5-embed: lazy src, click-to-play,
   muted autoplay), countdown timers (gp-countdown-timer: daily / evergreen / fixed date), delivery estimates
   (gp-estimate-date), image comparison (gp-image-comparison).
   Product galleries (gp-product-images) belong to assets/sb-gp-product.js and are skipped here, as is anything
   inside [data-sb-gp-own]. Every section script tag loads this file; it runs once and re-runs per section on the
   theme editor's shopify:section:load. Settings come from each element's own <script gp-data> JSON (the source's). */
(function () {
  'use strict';
  if (window.sbGp) return;
  var sbGp = (window.sbGp = { version: 1 });

  // ------------------------------------------------------------------ helpers
  function $$(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function def(v) { return v !== undefined && v !== null && v !== ''; }
  function gpData(el) {
    var s = null;
    for (var i = 0; i < el.children.length; i++) { if (el.children[i].tagName === 'SCRIPT' && el.children[i].hasAttribute('gp-data')) { s = el.children[i]; break; } }
    var raw = s ? s.textContent : el.getAttribute('gp-data');
    if (!raw) return {};
    try { return JSON.parse(raw); } catch (e) { return {}; }
  }
  function device() { var w = window.innerWidth; return w < 768 ? 'mobile' : w < 1025 ? 'tablet' : 'desktop'; }
  function resp(v, dev) {
    if (v === null || typeof v !== 'object' || Array.isArray(v)) return v;
    if (!('desktop' in v) && !('tablet' in v) && !('mobile' in v)) return v;
    dev = dev || device();
    if (dev === 'mobile') return def(v.mobile) ? v.mobile : def(v.tablet) ? v.tablet : v.desktop;
    if (dev === 'tablet') return def(v.tablet) ? v.tablet : v.desktop;
    return v.desktop;
  }
  function num(v, d) { var n = parseFloat(v); return isNaN(n) ? d : n; }
  function owned(el) { return !!(el.closest && el.closest('gp-product-images, gp-product-images-v3, [data-sb-gp-own]')); }
  function once(el, key) { if (el['__sbgp_' + key]) return false; el['__sbgp_' + key] = true; return true; }
  var resizers = [];
  var rT = null;
  window.addEventListener('resize', function () { clearTimeout(rT); rT = setTimeout(function () { resizers.forEach(function (f) { try { f(); } catch (e) {} }); }, 120); });

  // ------------------------------------------------------------------ carousels
  function initCarousel(root) {
    if (owned(root) || !once(root, 'car')) return;
    var d = gpData(root);
    var st = d.setting || {};
    var sty = d.styles || {};
    var id = (root.getAttribute('data-id') || '').replace(/^gp-carousel-/, '');
    var viewport = root.querySelector('#gp-carousel-' + (window.CSS && CSS.escape ? CSS.escape(id) : id)) || root.querySelector('[id^="gp-carousel-"]');
    if (!viewport) return;
    // v3 (Swiper): viewport > .gem-slider-wrapper > slides, widths set here. v7: the viewport itself is the flex
    // track (.gem-slider), slide widths and the gap come from the server's --minw / --cg; it is scrolled.
    var wrapper = viewport.querySelector('.gem-slider-wrapper');
    var v7 = !wrapper;
    var track = wrapper || viewport;
    var slides = Array.prototype.filter.call(track.children, function (c) { return c.classList.contains('gem-slider-item'); });
    if (!slides.length) return;
    // controls of THIS carousel only: a carousel nested inside a slide (a product card's gallery) has its own
    function mine(sel) {
      var all = $$(root, sel);
      for (var i = 0; i < all.length; i++) { var c = all[i].parentElement && all[i].parentElement.closest('gp-carousel, gp-carousel-v3, gp-product-images, gp-product-images-v3'); if (c === root) return all[i]; }
      return null;
    }
    var dotsBox = (root.parentElement && root.parentElement.querySelector('.gp-carousel-dot-container-' + (window.CSS && CSS.escape ? CSS.escape(id) : id))) || mine('.gp-carousel-dot-container');
    var dotId = v7 ? 'gp-carousel-' + id + '-' : 'gp-dot-item-' + id + '-';
    var prevBtn = mine('button[aria-label="Carousel Back Arrow"], .gp-carousel-arrow-prev, [class*="gp-carousel-action-back"]');
    var nextBtn = mine('button[aria-label="Carousel Next Arrow"], .gp-carousel-arrow-next, [class*="gp-carousel-action-next"]');
    var index = Math.max(0, num(st.activeIndex, 0));
    var per = 1, gap = 0, step = 0, count = slides.length, loop = false, maxIndex = 0;
    var speed = num(sty.playSpeed, 500);
    var ease = st.animationMode || 'ease';
    viewport.style.overflow = 'hidden';
    if (!v7) {
      viewport.style.width = viewport.style.width || '100%';
      viewport.style.flex = viewport.style.flex || '1';
      wrapper.style.display = 'flex';
      wrapper.style.willChange = 'transform';
    }

    // arrows: the server HTML hides them (--v:hidden) until GemPages' JS shows them where navigation is on
    function arrows(dev) {
      var on = resp(st.navigationEnable, dev) !== false;
      var hover = !!resp(st.showWhenHover, dev);
      [prevBtn, nextBtn].forEach(function (b) {
        if (!b) return;
        if (on && !hover) { b.style.removeProperty('--v'); b.style.visibility = 'visible'; }
        else if (on && hover) { b.style.setProperty('--v', 'hidden'); b.style.visibility = ''; }
        else { b.style.setProperty('--v', 'hidden'); b.style.visibility = 'hidden'; }
      });
      root.__sbgpHoverArrows = on && hover;
    }
    if (prevBtn || nextBtn) {
      root.addEventListener('mouseenter', function () { if (root.__sbgpHoverArrows) [prevBtn, nextBtn].forEach(function (b) { if (b) b.style.visibility = 'visible'; }); });
      root.addEventListener('mouseleave', function () { if (root.__sbgpHoverArrows) [prevBtn, nextBtn].forEach(function (b) { if (b) b.style.visibility = ''; }); });
    }
    function layout() {
      var dev = device();
      arrows(dev);
      if (v7) {
        loop = !!resp(st.loop, dev);
        var a = slides[0].getBoundingClientRect();
        var b2 = slides[1] ? slides[1].getBoundingClientRect() : null;
        step = b2 ? b2.left - a.left : a.width;
        if (step <= 0) step = a.width || 1;
        gap = step - a.width;
        per = Math.max(1, (viewport.clientWidth + gap) / step);
        maxIndex = Math.max(0, Math.ceil(count - per - 0.01));
        if (index > maxIndex && !loop) index = maxIndex;
        buildDots();
        go(index, false);
        return;
      }
      per = Math.max(1, num(resp(st.itemNumber, dev), 1));
      gap = num(resp(sty.spacing, dev), 0);
      loop = !!resp(st.loop, dev);
      var sneak = !!resp(st.sneakPeak, dev);
      var sneakType = resp(st.sneakPeakType, dev) || 'forward';
      // GemPages: a sneak peek shows (items - 1) whole slides plus (100 - offset)% of the next one
      if (sneak && per > 1) {
        var off = num(resp(sneakType === 'center' ? st.sneakPeakOffsetCenter : st.sneakPeakOffsetForward, dev), 50);
        per = (per - 1) + (100 - off) / 100;
      }
      // the slides' own CSS (--minw: calc(100% / per - gap)) resolves 100% against the track, i.e. the viewport's
      // CONTENT box: a viewport padding (the 44 px sneak-peek inset of the home Best Sellers) is not slide room
      var vcs = window.getComputedStyle(viewport);
      var W = (viewport.clientWidth - (parseFloat(vcs.paddingLeft) || 0) - (parseFloat(vcs.paddingRight) || 0)) || root.clientWidth;
      var w = Math.max(10, (W - gap * (per - 1)) / per);
      step = w + gap;
      slides.forEach(function (s) {
        s.style.width = w + 'px';
        s.style.minWidth = w + 'px';
        s.style.maxWidth = w + 'px';
        s.style.flexShrink = '0';
        s.style.marginRight = gap + 'px';
      });
      maxIndex = Math.max(0, Math.ceil(count - per));
      if (index > maxIndex && !loop) index = maxIndex;
      wrapper.style.width = '';
      buildDots();
      go(index, false);
    }
    function pages() { return loop ? count : maxIndex + 1; }
    function buildDots() {
      if (!dotsBox) return;
      var show = !!resp(st.dot, device()) && pages() > 1;
      dotsBox.style.display = show ? '' : 'none';
      if (!show) return;
      if (dotsBox.__n === pages()) return;
      dotsBox.__n = pages();
      dotsBox.innerHTML = '';
      var size = num(resp(st.dotSize, device()), 12);
      for (var i = 0; i < pages(); i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.id = dotId + i;
        b.setAttribute('data-index', i);
        b.setAttribute('aria-label', 'dot');
        b.className = 'gp-carousel-dot';
        b.style.cssText = 'aspect-ratio:1/1;width:' + size + 'px;border-radius:9999px;box-shadow:0 4px 6px -1px rgba(0,0,0,.1);';
        (function (k) { b.addEventListener('click', function () { go(k, true); restart(); }); })(i);
        dotsBox.appendChild(b);
      }
    }
    function paintDots() {
      if (!dotsBox) return;
      var dev = device();
      var on = resp(st.dotActiveColor, dev) || '#121212';
      var off = resp(st.dotColor, dev) || 'rgba(18,18,18,.3)';
      $$(dotsBox, '.gp-carousel-dot').forEach(function (b, i) {
        var active = i === index;
        b.classList.toggle('gp-carousel-dot--active', active);
        b.classList.toggle('gem-slider-dot-active', active);
        b.classList.toggle('gem-slider-dot-inactive', !active);
        b.style.backgroundColor = active ? on : off;
      });
    }
    function go(i, animate) {
      if (loop) index = ((i % count) + count) % count;
      else index = Math.min(Math.max(0, i), maxIndex);
      // never scroll past the last slide (a looped row wraps to the start instead of showing blank space)
      var x = Math.min(index * step, Math.max(0, count * step - gap - viewport.clientWidth));
      if (v7) {
        try { viewport.scrollTo({ left: x, behavior: animate === false ? 'auto' : 'smooth' }); } catch (e) { viewport.scrollLeft = x; }
      } else {
        wrapper.style.transition = animate === false ? 'none' : 'transform ' + speed + 'ms ' + ease;
        wrapper.style.transform = 'translate3d(' + (-x) + 'px,0,0)';
      }
      slides.forEach(function (s, k) {
        s.classList.toggle('swiper-slide-active', k === index);
        s.classList.toggle('swiper-slide-next', k === index + 1);
        s.classList.toggle('swiper-slide-prev', k === index - 1);
      });
      root.setAttribute('active-index', index);
      paintDots();
      if (prevBtn && !loop) prevBtn.toggleAttribute('disabled', index <= 0);
      if (nextBtn && !loop) nextBtn.toggleAttribute('disabled', index >= maxIndex);
    }
    function next() { go(index + 1 > (loop ? count - 1 : maxIndex) ? (loop ? 0 : maxIndex) : index + 1, true); }
    function prev() { go(index - 1 < 0 ? (loop ? count - 1 : 0) : index - 1, true); }
    if (prevBtn) prevBtn.addEventListener('click', function (e) { e.preventDefault(); prev(); restart(); });
    if (nextBtn) nextBtn.addEventListener('click', function (e) { e.preventDefault(); next(); restart(); });
    // swipe / drag
    var sx = null, sy = null, dragging = false, base = 0, moved = false;
    viewport.style.touchAction = 'pan-y';
    viewport.addEventListener('pointerdown', function (e) {
      if (e.button !== 0 || resp(st.enableDrag) === false) return;
      sx = e.clientX; sy = e.clientY; dragging = true; moved = false;
      if (v7) base = -viewport.scrollLeft;
      else { var m = /translate3d\((-?[\d.]+)px/.exec(wrapper.style.transform || ''); base = m ? parseFloat(m[1]) : 0; }
    });
    window.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - sx;
      if (!moved && Math.abs(dx) < 6) return;
      if (!moved && Math.abs(e.clientY - sy) > Math.abs(dx)) { dragging = false; return; }
      moved = true;
      if (v7) { viewport.scrollLeft = -(base + dx); return; }
      wrapper.style.transition = 'none';
      wrapper.style.transform = 'translate3d(' + (base + dx) + 'px,0,0)';
    });
    window.addEventListener('pointerup', function (e) {
      if (!dragging) return;
      dragging = false;
      if (!moved) return;
      var dx = e.clientX - sx;
      var n = Math.max(1, Math.round(Math.abs(dx) / step));
      if (dx < -40) go(loop ? index + n : Math.min(index + n, maxIndex), true);
      else if (dx > 40) go(loop ? index - n : Math.max(index - n, 0), true);
      else go(index, true);
      restart();
    });
    viewport.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    // autoplay
    var timer = null, hover = false;
    function restart() {
      clearInterval(timer);
      if (!st.autoplay) return;
      timer = setInterval(function () { if (!(hover && st.pauseOnHover) && !document.hidden) next(); }, Math.max(1, num(st.autoplayTimeout, 3)) * 1000);
    }
    root.addEventListener('mouseenter', function () { hover = true; });
    root.addEventListener('mouseleave', function () { hover = false; });
    layout();
    restart();
    resizers.push(layout);
    root.sbGoTo = function (i) { go(i, true); };
  }

  // ------------------------------------------------------------------ marquees (react-fast-marquee layout)
  function initMarquee(root) {
    if (!once(root, 'mq')) return;
    var st = (gpData(root).setting) || {};
    var box = root.querySelector('.rfm-marquee-container');
    if (!box) return;
    var tracks = $$(box, ':scope > .rfm-marquee');
    var first = tracks[0];
    var ghost = tracks[1];
    var initial = first && first.querySelector('.rfm-initial-child-container');
    if (!first || !initial) return;
    var item = initial.querySelector('.rfm-child');
    var pxs = num(st.speed, 0.5) * 100;
    function fill() {
      $$(box, '.rfm-child-placeholder').forEach(function (n) { n.remove(); });
      var W = box.clientWidth;
      var w = initial.getBoundingClientRect().width;
      if (!W || !w || !item) { first.style.setProperty('--duration', '0s'); if (ghost) ghost.style.setProperty('--duration', '0s'); return; }
      var mult = w < W ? Math.ceil(W / w) : 1;
      for (var i = 1; i < mult; i++) { var c = item.cloneNode(true); c.classList.add('rfm-child-placeholder'); first.appendChild(c); }
      if (ghost) for (var j = 0; j < mult; j++) { var g = item.cloneNode(true); g.classList.add('rfm-child-placeholder'); ghost.appendChild(g); }
      var dur = (w * mult) / pxs;
      [first, ghost].forEach(function (t) {
        if (!t) return;
        t.style.setProperty('--duration', dur + 's');
        t.style.setProperty('--direction', st.direction === 'right' ? 'reverse' : 'normal');
      });
      if (st.stopOnHover) box.style.setProperty('--pause-on-hover', 'paused');
    }
    fill();
    resizers.push(fill);
  }

  // ------------------------------------------------------------------ tabs
  function initTab(root) {
    if (!once(root, 'tab')) return;
    var st = gpData(root).setting || {};
    var heads = $$(root, '.gp-tab-header-list > .gp-navs-tab, .gp-tab-header-list > li');
    var cont = root.querySelector('.gp-tab-item-container');
    if (!heads.length || !cont) return;
    var panels = Array.prototype.filter.call(cont.children, function (c) { return c.classList.contains('gp-tab-item'); });
    var active = Math.max(0, num(st.activeKey, 0));
    if (active >= heads.length) active = 0;
    var onStyle = heads[active].getAttribute('style') || '';
    var offStyle = (heads[active === 0 ? 1 : 0] || heads[active]).getAttribute('style') || '';
    function show(i) {
      heads.forEach(function (h, k) { h.setAttribute('style', k === i ? onStyle : offStyle); h.classList.toggle('gp-tab-active', k === i); h.setAttribute('data-active', k === i ? 'true' : 'false'); });
      panels.forEach(function (p, k) {
        var on = k === i;
        p.style.setProperty('--v', on ? 'visible' : 'hidden');
        p.style.setProperty('--pos', on ? 'relative' : 'absolute');
        p.style.visibility = on ? 'visible' : 'hidden';
        p.style.position = on ? 'relative' : 'absolute';
        p.style.height = on ? 'auto' : '0px';
        p.style.overflow = on ? 'unset' : 'hidden';
      });
    }
    heads.forEach(function (h, k) { h.addEventListener('click', function () { show(k); }); });
    show(active);
  }

  // ------------------------------------------------------------------ accordions
  function initAccordion(root) {
    if (!once(root, 'acc')) return;
    var st = gpData(root).setting || {};
    var items = $$(root, '.gp-accordion-item').filter(function (c) { return c.closest('gp-accordion') === root; });
    var multi = !!st.expandItem;
    function iconFor(open) { return open ? (st.iconExpand || st.iconCollapse) : (st.iconCollapse || st.iconExpand); }
    function set(item, open, animate) {
      var body = item.querySelector('.gp-accordion-item_body');
      var icon = item.querySelector('.gp-accordion-item_icon');
      if (!body) return;
      body.setAttribute('data-show', open ? 'true' : 'false');
      item.setAttribute('data-active', open ? 'true' : 'false');
      body.style.gridTemplateRows = open ? '1fr' : '0fr';
      if (icon && !st.isIconPlus && st.iconExpand && st.iconCollapse) {
        var html = iconFor(open);
        if (icon.__open !== open) { icon.innerHTML = html; icon.__open = open; }
      } else if (icon) icon.style.transform = open ? 'rotate(' + (st.isIconPlus ? 45 : 180) + 'deg)' : '';
    }
    var activeKey = st.activeKey !== undefined ? parseInt(st.activeKey, 10) : -1;
    items.forEach(function (item, k) {
      var head = item.querySelector('.gp-accordion-item_header');
      var body = item.querySelector('.gp-accordion-item_body');
      if (head && head.closest('.gp-accordion-item') !== item) head = null;
      var open = body && body.getAttribute('data-show') === 'true';
      if (st.expanded && k === activeKey) open = true;
      set(item, !!open, false);
      if (head) head.addEventListener('click', function () {
        var now = item.getAttribute('data-active') !== 'true';
        if (now && !multi) items.forEach(function (o) { if (o !== item) set(o, false, true); });
        set(item, now, true);
      });
    });
  }

  // ------------------------------------------------------------------ dialogs + popup / scroll links
  function dialogFor(key) {
    if (!key) return null;
    key = key.replace(/^#/, '').replace(/^el-/, '');
    return document.querySelector('dialog[data-gp-dialog-id="' + key + '"]') || (function () {
      var host = document.querySelector('[data-id="' + key + '"], #' + CSS.escape(key));
      return host && (host.tagName === 'DIALOG' ? host : host.querySelector('dialog'));
    })();
  }
  function openDialog(dlg) {
    if (!dlg) return false;
    try { if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', ''); } catch (e) { dlg.setAttribute('open', ''); }
    document.documentElement.style.overflow = 'hidden';
    return true;
  }
  function closeDialog(dlg) {
    if (!dlg) return;
    try { if (dlg.close) dlg.close(); } catch (e) {}
    dlg.removeAttribute('open');
    document.documentElement.style.overflow = '';
  }
  function initDialog(root) {
    if (!once(root, 'dlg')) return;
    var dlg = root.querySelector('dialog');
    if (!dlg) return;
    var setting = {};
    try { setting = JSON.parse(root.getAttribute('data-gp-setting') || '{}'); } catch (e) {}
    $$(dlg, '[data-gp-dialog-close]').forEach(function (b) { b.addEventListener('click', function () { closeDialog(dlg); }); });
    var overlay = dlg.querySelector('[data-gp-dialog-overlay]');
    if (setting.closeOnClickOutside !== false) {
      dlg.addEventListener('click', function (e) {
        var content = dlg.querySelector('[role="dialog"]');
        if (content && !content.contains(e.target)) closeDialog(dlg);
        else if (overlay && e.target === overlay) closeDialog(dlg);
      });
    }
    dlg.addEventListener('cancel', function () { document.documentElement.style.overflow = ''; });
  }
  function scrollToTarget(hash) {
    if (hash === '#scroll-to-top' || hash === '#top') { window.scrollTo({ top: 0, behavior: 'smooth' }); return true; }
    var key = hash.replace(/^#/, '');
    if (!key) return false;
    var t = null;
    try { t = document.getElementById(key) || document.querySelector('[data-id="' + key + '"]') || document.querySelector('.' + CSS.escape(key)); } catch (e) {}
    if (!t) return false;
    var r = t.getBoundingClientRect();
    var header = document.querySelector('header, .header, .header-wrapper');
    var off = header && getComputedStyle(header).position === 'sticky' ? header.getBoundingClientRect().height : 0;
    window.scrollTo({ top: window.pageYOffset + r.top - off, behavior: 'smooth' });
    return true;
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href^="#"]');
    if (!a || !a.closest('.gps')) return;
    var href = a.getAttribute('href');
    if (!href || href === '#') return;
    var btn = a.closest('gp-button');
    var link = {};
    if (btn) { try { link = (JSON.parse(btn.getAttribute('gp-data') || '{}').btnLink) || {}; } catch (er) {} }
    if (link.type === 'open-popup' || /^#el-/.test(href)) {
      if (openDialog(dialogFor(href))) { e.preventDefault(); return; }
    }
    if (scrollToTarget(href)) e.preventDefault();
  });

  // ------------------------------------------------------------------ videos
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      io.unobserve(en.target);
      loadVideo(en.target, en.target.hasAttribute('autoplay'));
    });
  }, { rootMargin: '300px 0px' }) : null;
  function loadVideo(v, play) {
    var src = v.getAttribute('data-src');
    var srcs = $$(v, 'source[data-src]').filter(function (s) { return !s.getAttribute('src') && s.getAttribute('data-src'); });
    srcs.forEach(function (s) { s.setAttribute('src', s.getAttribute('data-src')); });
    if (src && !v.getAttribute('src') && !v.querySelector('source[src]')) v.setAttribute('src', src);
    if (srcs.length || (src && v.getAttribute('src') === src && !v.hasAttribute('data-sb-loaded'))) { v.setAttribute('data-sb-loaded', ''); try { v.load(); } catch (e) {} }
    if (play) { v.muted = v.muted || v.hasAttribute('muted'); var p = v.play && v.play(); if (p && p.catch) p.catch(function () {}); }
  }
  function initVideo(root) {
    if (!once(root, 'vid')) return;
    var v = root.querySelector('video');
    if (!v) return;
    var thumb = root.querySelector('.gp-thumbnail-video');
    var play = thumb && (thumb.querySelector('button[aria-label="Play"]') || thumb);
    if (v.hasAttribute('autoplay') || !thumb) {
      if (v.hasAttribute('muted')) v.muted = true;
      if (io) io.observe(v); else loadVideo(v, v.hasAttribute('autoplay'));
      return;
    }
    if (v.getAttribute('preload') !== 'none' && io) io.observe(v);
    function start() {
      loadVideo(v, false);
      v.classList.remove('gp-invisible');
      v.style.visibility = 'visible';
      if (thumb) thumb.style.display = 'none';
      var p = v.play && v.play(); if (p && p.catch) p.catch(function () {});
    }
    if (play) play.addEventListener('click', function (e) { e.preventDefault(); start(); });
    if (thumb && thumb !== play) thumb.addEventListener('click', start);
  }

  // ------------------------------------------------------------------ countdown timers
  function initCountdown(root) {
    if (!once(root, 'cd')) return;
    var st = gpData(root);
    st = st.setting || st;
    var behaviour = st.behaviour || 'standard';
    function target() {
      var now = Date.now();
      if (behaviour === 'daily') {
        var t = st.timerDaily || {};
        var h = num(t.hours, 0) % 12 + (t.format === 'pm' ? 12 : 0);
        var d = new Date(); d.setHours(h, num(t.mins, 0), 0, 0);
        if (d.getTime() <= now) d.setDate(d.getDate() + 1);
        return d.getTime();
      }
      if (behaviour === 'evergreen') {
        var e = st.timerEverygreen || {};
        var span = ((num(e.days, 0) * 24 + num(e.hours, 0)) * 60 + num(e.mins, 0)) * 60000 + num(e.seconds, 0) * 1000;
        if (span <= 0) span = 3600000;
        var key = 'sbgp-cd-' + (root.getAttribute('data-id') || '');
        var start = 0;
        try { start = parseInt(localStorage.getItem(key) || '0', 10); } catch (er) {}
        if (!start || (now - start >= span && st.loopAfterFinish !== false)) {
          if (start && st.loopAfterFinish !== false) start = start + Math.floor((now - start) / span) * span;
          else start = now;
          try { localStorage.setItem(key, String(start)); } catch (er) {}
        }
        return start + span;
      }
      var ds = Date.parse(st.dateStandard || '');
      return isNaN(ds) ? now : ds;
    }
    var end = target();
    var units = { week: 604800, day: 86400, hour: 3600, minute: 60, second: 1 };
    var nodes = {};
    Object.keys(units).forEach(function (u) {
      nodes[u] = root.querySelector('[data-unit="' + u + '"], .gp-countdown-' + u + ' .gp-countdown-number, [class*="countdown-' + u + '"] [class*="number"], #' + CSS.escape((root.getAttribute('data-id') || '') + '-' + u));
    });
    var numberEls = $$(root, '[class*="countdown-number"], .gp-countdown-value, [data-countdown-number]');
    function tick() {
      var left = Math.max(0, Math.floor((end - Date.now()) / 1000));
      if (left <= 0 && st.loopAfterFinish !== false && behaviour !== 'standard') { end = target(); left = Math.max(0, Math.floor((end - Date.now()) / 1000)); }
      var enabled = ['week', 'day', 'hour', 'minute', 'second'].filter(function (u) {
        var k = 'enable' + u[0].toUpperCase() + u.slice(1);
        return st[k] !== false;
      });
      var vals = {};
      var rest = left;
      enabled.forEach(function (u) { vals[u] = Math.floor(rest / units[u]); rest -= vals[u] * units[u]; });
      var i = 0;
      enabled.forEach(function (u) {
        var txt = vals[u] < 10 ? '0' + vals[u] : String(vals[u]);
        var el = nodes[u] || numberEls[i];
        if (el && el.textContent !== txt) el.textContent = txt;
        i++;
      });
      if (left <= 0 && behaviour === 'standard' && st.autoHideWhenTimeout) root.style.display = 'none';
    }
    tick();
    setInterval(tick, 1000);
  }

  // ------------------------------------------------------------------ delivery estimates
  function fmtDate(d, fmt) {
    var M = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    var D = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    var day = d.getDate();
    return (fmt || '%b %d').replace(/%([a-zA-Z])/g, function (m, c) {
      switch (c) {
        case 'd': return String(day); case 'D': return (day < 10 ? '0' : '') + day;
        case 'b': return M[d.getMonth()].slice(0, 3); case 'B': return M[d.getMonth()];
        case 'm': return String(d.getMonth() + 1); case 'y': case 'Y': return String(d.getFullYear());
        case 'a': return D[d.getDay()].slice(0, 3); case 'A': return D[d.getDay()];
        default: return m;
      }
    });
  }
  function initEstimate(root) {
    if (!once(root, 'est')) return;
    $$(root, '[setting-estimate-date]').forEach(function (box) {
      var s = {};
      try { s = JSON.parse(decodeURIComponent(box.getAttribute('setting-estimate-date') || '')); } catch (e) {}
      var min = num(s.minEstimate, 2), max = num(s.maxEstimate, 5);
      var a = new Date(); a.setDate(a.getDate() + min);
      var b = new Date(); b.setDate(b.getDate() + max);
      var fmt = s.typeFormat === 'Custom' ? s.customFormat : '%b %d';
      var range = s.typeEstimate === 'specific' ? fmtDate(a, fmt) + ' - ' + fmtDate(b, fmt) : fmtDate(b, fmt);
      var target = box.querySelector('[data-estimate-date], .gp-estimate-date-value') || box.querySelector('span:last-child') || box;
      var label = s.enableCustomText && s.customText ? s.customText + ' ' : '';
      if (target === box) box.textContent = label + range;
      else target.textContent = (target === box.querySelector('span:last-child') && box.querySelectorAll('span').length === 1 ? label : '') + range;
      var wrap = box.closest('.trigger-hidden-class, .\\!gp-hidden') || box.parentElement;
      for (var p = box; p && p !== root.parentElement; p = p.parentElement) { if (p.classList && p.classList.contains('!gp-hidden')) p.classList.remove('!gp-hidden'); }
      if (wrap && wrap.classList) wrap.classList.remove('trigger-hidden-class');
    });
  }

  // ------------------------------------------------------------------ image comparison
  function initCompare(root) {
    if (!once(root, 'cmp')) return;
    var st = gpData(root);
    var box = root.querySelector('[class*="comparison"], .gp-relative') || root;
    var handle = root.querySelector('[class*="handle"], [role="slider"]');
    var top = root.querySelector('[class*="left-image"], [class*="before"], img + div, .gp-image-comparison-left');
    function set(p) {
      p = Math.min(100, Math.max(0, p));
      root.style.setProperty('--sb-cmp', p + '%');
      if (top) top.style.clipPath = st.vertical ? 'inset(0 0 ' + (100 - p) + '% 0)' : 'inset(0 ' + (100 - p) + '% 0 0)';
      if (handle) { if (st.vertical) handle.style.top = p + '%'; else handle.style.left = p + '%'; }
    }
    var down = false;
    function move(e) {
      var r = box.getBoundingClientRect();
      var p = st.vertical ? (e.clientY - r.top) / r.height * 100 : (e.clientX - r.left) / r.width * 100;
      set(p);
    }
    box.addEventListener('pointerdown', function (e) { down = true; move(e); });
    window.addEventListener('pointermove', function (e) { if (down || st.hover) { if (box.contains(e.target) || down) move(e); } });
    window.addEventListener('pointerup', function () { down = false; });
    box.style.touchAction = 'pan-y';
  }

  // ------------------------------------------------------------------ reels (EcoBoostify playlist, rebuilt)
  function initReels(root) {
    if (!once(root, 'reels')) return;
    var track = root.querySelector('.sb-gp-reels__track');
    if (!track) return;
    var orig = Array.prototype.slice.call(track.children);
    var n = orig.length;
    if (!n) return;
    var loop = root.getAttribute('data-loop') !== 'false' && n > 1;
    var clones = loop ? Math.min(n, 4) : 0;
    if (loop) {
      for (var i = 0; i < clones; i++) {
        var a = orig[n - 1 - i].cloneNode(true); a.setAttribute('aria-hidden', 'true'); track.insertBefore(a, track.firstChild);
        var b = orig[i].cloneNode(true); b.setAttribute('aria-hidden', 'true'); track.appendChild(b);
      }
    }
    var all = Array.prototype.slice.call(track.children);
    var active = 0, step = 0, w = 0;
    function layout() {
      var mob = device() === 'mobile';
      var tab = device() === 'tablet';
      var cd = num(root.getAttribute('data-cols-desktop'), 6), cm = num(root.getAttribute('data-cols-mobile'), 2);
      var cols = mob ? cm : tab ? Math.max(cm, Math.round((cd + cm) / 2)) : cd;
      var gap = num(root.getAttribute(mob ? 'data-gap-mobile' : 'data-gap-desktop'), 8);
      var W = root.clientWidth;
      w = (W - gap * (cols - 1)) / cols;
      step = w + gap;
      all.forEach(function (s) { s.style.width = w + 'px'; s.style.marginRight = gap + 'px'; });
      go(active, false);
    }
    function go(i, animate) {
      active = loop ? ((i % n) + n) % n : Math.max(0, Math.min(n - 1, i));
      var W = root.clientWidth;
      var x = (clones + active) * step - (root.getAttribute('data-align') === 'center' ? (W - w) / 2 : 0);
      track.style.transition = animate ? 'transform 300ms ease' : 'none';
      track.style.transform = 'translate3d(' + (-x) + 'px,0,0)';
    }
    var sx = null, moved = false;
    track.addEventListener('pointerdown', function (e) { sx = e.clientX; moved = false; });
    window.addEventListener('pointerup', function (e) {
      if (sx === null) return;
      var dx = e.clientX - sx; sx = null;
      if (Math.abs(dx) > 40) { moved = true; go(active + (dx < 0 ? 1 : -1) * Math.max(1, Math.round(Math.abs(dx) / step)), true); }
    });
    track.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); moved = false; return; }
      var card = e.target.closest('.sb-gp-reels__card');
      if (!card) return;
      var v = card.querySelector('video');
      if (!v) return;
      if (card.classList.contains('is-playing')) { if (v.paused) v.play(); else v.pause(); return; }
      $$(track, '.sb-gp-reels__card.is-playing video').forEach(function (o) { o.pause(); });
      if (!v.getAttribute('src') && v.getAttribute('data-src')) v.setAttribute('src', v.getAttribute('data-src'));
      card.classList.add('is-playing');
      v.muted = false;
      v.setAttribute('controls', '');
      var p = v.play(); if (p && p.catch) p.catch(function () { v.muted = true; v.play().catch(function () {}); });
    });
    layout();
    resizers.push(layout);
  }

  // ------------------------------------------------------------------ tablet text fit
  // GemPages' tablet sizes (768-1024 px, a width the source was never captured at) squeeze some text boxes so far that
  // a word breaks inside ("Metabolis/m", "KARE/N", "FRE/E!"). The element holding such a word gets a smaller font,
  // step by step down to 70 %, until no word is split across lines; a fixed-width text box that sticks out of the
  // screen gets width:auto. Phones and desktops (the captured widths) are never touched; leaving the range undoes it.
  var FIT_MQ = '(min-width:768px) and (max-width:1024px)';
  var fitted = [];
  var WORD = /[^\s ­\-‐-—\/|,.;:!?()]{2,}/g;
  function splitWords(root, onSplit) {
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var r = document.createRange();
    var n, m, any = false;
    while ((n = w.nextNode())) {
      if (!n.parentElement || !n.data.trim()) continue;
      WORD.lastIndex = 0;
      while ((m = WORD.exec(n.data))) {
        r.setStart(n, m.index);
        r.setEnd(n, m.index + m[0].length);
        var rs = r.getClientRects();
        if (rs.length > 1 && Math.abs(rs[0].top - rs[rs.length - 1].top) > 2) { any = true; if (!onSplit || onSplit(n.parentElement)) return true; break; }
      }
    }
    return any;
  }
  function unfit() {
    fitted.forEach(function (f) { f[0].style.setProperty(f[1], f[2], f[3]); });
    fitted = [];
  }
  function fitTablet() {
    unfit();
    if (!window.matchMedia(FIT_MQ).matches) return;
    var keep = function (el, prop) { fitted.push([el, prop, el.style.getPropertyValue(prop), el.style.getPropertyPriority(prop)]); };
    // fixed-width text boxes wider than the screen allows (a GemPages px width at tablet): their content width instead
    var vw = document.documentElement.clientWidth;
    $$(document, '.gps .gp-text').forEach(function (el) {
      if (owned(el) || !el.offsetParent) return;
      var b = el.getBoundingClientRect();
      if (b.width > 0 && (b.right > vw + 0.5 || b.left < -0.5) && /--w(?:-tablet)?:\s*\d/.test(el.getAttribute('style') || '')) {
        keep(el, 'width'); keep(el, 'max-width');
        el.style.setProperty('width', 'auto', 'important');
        el.style.setProperty('max-width', '100%', 'important');
      }
    });
    // tab header rows (one row at the captured widths; the tabs keep their labels whole, base CSS): the labels shrink
    // together until the row fits again, else the row wraps
    $$(document, '.gps .gp-tab-header-list').forEach(function (ul) {
      if (!ul.offsetParent || ul.scrollWidth <= ul.clientWidth + 1) return;
      var labels = $$(ul, '[style*="--size"]');
      var bases = labels.map(function (l) { keep(l, 'font-size'); return parseFloat(window.getComputedStyle(l).fontSize) || 0; });
      for (var f = 0.95; f > 0.69 && ul.scrollWidth > ul.clientWidth + 1; f -= 0.05) {
        labels.forEach(function (l, i) { if (bases[i]) l.style.setProperty('font-size', (bases[i] * f).toFixed(2) + 'px', 'important'); });
      }
      if (ul.scrollWidth > ul.clientWidth + 1) { keep(ul, 'flex-wrap'); ul.style.setProperty('flex-wrap', 'wrap', 'important'); }
    });
    // words split inside: the element holding the text gets a smaller font
    var holders = [];
    $$(document, '.gps .gp-text').forEach(function (el) {
      if (owned(el) || !el.offsetParent) return;
      splitWords(el, function (h) { if (holders.indexOf(h) < 0) holders.push(h); return false; });
    });
    holders.forEach(function (h) {
      var base = parseFloat(window.getComputedStyle(h).fontSize);
      if (!base) return;
      keep(h, 'font-size');
      for (var f = 0.95; f > 0.69 && splitWords(h); f -= 0.05) h.style.setProperty('font-size', (base * f).toFixed(2) + 'px', 'important');
      if (!splitWords(h)) return;
      // no size fits: the font as it was, and the text box at least as wide as its longest word (when that fits)
      var k = fitted.pop();
      h.style.setProperty(k[1], k[2], k[3]);
      var box = h.closest('.gp-text') || h;
      keep(box, 'min-width');
      keep(box, 'word-break');
      box.style.setProperty('word-break', 'normal', 'important');
      box.style.setProperty('min-width', 'min-content', 'important');
      if (document.documentElement.scrollWidth > vw + 0.5 || splitWords(h)) {
        for (var u = 0; u < 2; u++) { k = fitted.pop(); box.style.setProperty(k[1], k[2], k[3]); }
      }
    });
  }
  resizers.push(fitTablet);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { try { fitTablet(); } catch (e) {} });

  // ------------------------------------------------------------------ boot
  var INIT = [
    ['gp-carousel, gp-carousel-v3', initCarousel],
    ['gp-marquee', initMarquee],
    ['gp-tab', initTab],
    ['gp-accordion', initAccordion],
    ['gp-dialog', initDialog],
    ['gp-lite-html5-embed', initVideo],
    ['gp-countdown-timer', initCountdown],
    ['gp-estimate-date', initEstimate],
    ['gp-image-comparison', initCompare],
    ['[data-sb-gp-reels]', initReels],
  ];
  function init(scope) {
    scope = scope || document;
    INIT.forEach(function (p) { $$(scope, p[0]).forEach(function (el) { try { p[1](el); } catch (e) { if (window.console) console.warn('[sb-gp] ' + p[0], e); } }); });
  }
  sbGp.init = init;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  window.addEventListener('load', function () { resizers.forEach(function (f) { try { f(); } catch (e) {} }); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
